export const locale = {
    lang: 'zh2',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO':	'试行调研',
        'ENCUESTA_PILOTO_ENVIO': '发送试点调查',
        'ENCUESTA_LANZAMIENTO':'启动确认',
        'BTN_COPY':'複製調查碼 ',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'创建调查',
        'ENCUESTA_DEMO':'试点调查',
        'BOTON_CREAR_ENCUESTA':'产生调查',
        'SEE_TI': '请参阅技术要求',
        'CLAVE':	'存取资料',
        'ACCESO':	'存取',
        'NOFECHA':'您无法执行此操作，因为没有启动日期',
        'LABEL01':	'复制存取代码并粘贴到试行调研',
        'LABEL02':	'调查的发送已确认',
        'LABEL03':  '电子邮件',
        'LABEL04': '发送试点调查',
        'LABEL05': '错误',
        'LABEL06': '试点调查已正确发送',
        'LABEL07': '必填项目',
        'LABEL09': '调查演示用户已经筋疲力尽',
        'CONFIRMAR_ENVIO': '确认发送电子邮件',
        'DES_CONFIRMAR_ENVIO': '不确认发送电子邮件',
        'SI_CONFIRMAR_ENVIO': '是',
        'NO_CONFIRMAR_ENVIO': '没有',
        'CHANGE-OPTIONS':'更改邮件选项',
        'NO_ENVIO_CORREO':'没有邮件将被发送',
        'SI_ENVIO_CORREO':'邮件将被发送',
        'EN_CASO':'如果选择 "否"，则所有关于调查的通讯邮件都将于平台之外进行，即平台不会向用户发送电子邮件。',
        'CONFIRMAR_ENVIO_35': '确认调查提交', //
        'AUTOLOG_35': '调查自动登录链接：',
        'TITULO':'在本部分中，您将可以对调查进行测试运行：',
        'LINK':'1.访问以下链接：',
        'CLAVE_ENCUESTA':'2.复制此测试密钥：',
        'INSTRUCCION3':'3.将密钥粘贴到密码单元格中',
        'INSTRUCCION4':'4.点击登录',
        'TEXTO_CONFIRMAR':'确认将通过电子邮件与用户进行通信（邀请和提醒）',
        'TEXTO_CONFIRMAR2':'如果您不想发送邮件，只需跳过单击并关闭步骤',
        'TITULO_PILOTO':'在此部分中，您将能够在真正启动调查之前将参与邀请邮件发送给最多五个不同的协作者，以测试邮件的接收和调查的可视化：',
        'INSTRUCCION_PILOTO':'1.输入电子邮件，然后选择要用于接收邀请的语言',
        'INSTRUCCION_PILOTO2':'2.单击发送按钮',
        'SELLANG': '选择一种语言',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> 要确认不会发送邀请或提醒电子邮件，请在文本框中输入红色代码 ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'配置已修改',

        'BTN_MODALES':{
          'CONFIRMAR':'确认',
          'SALIR':'出口',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
          'MAS50':'更多 50',
          'MENOS50':'少一点 50'
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1.访问以下链接：',
          'CLAVE_ENCUESTA':'2. 复制“演示用户”部分中生成的密钥之一',
          'INSTRUCCION3':'3.将密钥粘贴到密码单元格中',
          'INSTRUCCION4':'4.点击登录',
          'USERSDEMO':'演示用户',
          'USERS':'用户',
          'CLAVE':'键',
          'ESTATUS':'状态',
          'ESTATUS-USER-ASIGNA':'已分配',
          'INST_UPD_URL_NAME':'通过键入最多6个字符的用户熟悉的文本来自定义ShortUrl。',
          'BTN_UPD_GUARDA':'救',
          'BTN_UPD_CAN':'取消',
          'CUS_SHOI_URL':'自定义调查URL',
          'MODAL_ACTU_CUS_SHOI_URL':'更新网址中的名称',
          'ACTU_CUS_SHOI_URL_OK':'网址中的名称已正确更新',
          'ACTU_CUS_SHOI_URL_FALSE':'网址中的名称已经存在',
        },


        'ALERT':{
          'HEADER':	'信息',
          'MESSAGE_CON': '¿您要确认向用户发送电子邮件?',
          'MESSAGE': '¿您是否要确认向合作者发送电子邮件?',
          'MESSAGE_DESCON': '¿您一定不要确认向用户发送电子邮件?',
          'BTN_CANCEL':	'不，请取消',
          'BTN_CONFIRM':	'是，请发送',
          'BTN_NO_CONFIRM': '不，发送',
          'BTN_SI_CONFIRM': '是的，发送',
          'BTN_NO_CANCEL': '取消',
          'BTN_OK': '是',
          'SINCOLABS': '您还不能发送调查邀请，必须先上传公司参与者列表',
          'SINLANG': '您尚未为输入的一个或多个电子邮件地址选择一种语言',
          'ERRMAIL': '输入的电子邮件语法不正确，请检查并再次输入'
        }

      },
      'PULSE':{
              'LABEL01': '将调查发送给您的合作者',
      }
    }
};
